module.exports = __webpack_public_path__ + "img/20210708104745.f333961d.gif";